import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { isLocalApi } from 'utils/localApi';

// Returns { status: 'PENDING' } until the worker has written anything, then
// { status: 'RUNNING', stage, doneFiles, totalFiles },
// { status: 'DONE', downloadUrl, fileName, fileCount, skippedFileCount, archiveBytes }
// (downloadUrl is signed fresh on every read; a createDownloadLink job also
// carries downloadLinkUrl and downloadLinkExpiresAt) or
// { status: 'FAILED', message }.
export const getProjectBankArchiveJobResult = async (
  projectId,
  archiveJobId
) => {
  const apiPath = `project-bank/${projectId}/archive-job/${archiveJobId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: isLocalApi(process.env.REACT_APP_LOCAL_API_PROJECT_BANK),
  });

  const response = await axios(signedRequest);

  return response.data;
};
